import styles from "../styles/GreenMagCashbackView.module.css";

const GreenMagCashbackView = () => {
  return (
    <div className={styles.container}>
      <h2>GreenMag Cashback</h2>
      <p>Информация о кэшбэках, бонусах и акциях для клиентов.</p>
    </div>
  );
};

export default GreenMagCashbackView;
